import React, { useState, useEffect, useContext } from 'react';
import {withRouter} from "../../lib/react/withRouter";
import sso from "../../sso";

class Reg_Home extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.pos = props.store.pos;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";

      this.state.mna = [];
      this.state.mna.push({ mnid: "mn01", pos: "c1", text: "EKO TRANSAKTIONER", desc: "", link: "/pms/hotreg/eko" });
      this.state.mna.push({ mnid: "mn02", pos: "c1", text: "RESURSER", desc: "", link: "/pms/hotreg/rs" });
      this.state.mna.push({ mnid: "mn03", pos: "c1", text: "RUMSTYPER", desc: "", link: "/pms/hotreg/rt" });
      this.state.mna.push({ mnid: "mn04", pos: "c2", text: "KONFERENS", desc: "", link: "/pms/hotreg/kt" });
      this.state.mna.push({ mnid: "mn05", pos: "c2", text: "SIGNATURER", desc: "", link: "/pms/hotreg/signs" });
      this.state.mna.push({ mnid: "mn06", pos: "c2", text: "ALLOTMENT", desc: "", link: "/pms/hotreg/allot" });
      this.state.mna.push({ mnid: "mn07", pos: "c2", text: "DAGSINFO", desc: "", link: "/pms/hotreg/di" });
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

    mnc(pos) {
        var mna = [];
        for(var row of this.state.mna) {
            if(row.pos == pos) mna.push( row );
        }
        return mna;
    }
  fknGo(url) {
    //alert(row.href);
    var row = {};
    row.url = url;
    sso.seo.sfkn = row;
    this.props.navigate(url);
  }

  render() {
    return (
    <div className="web-app">
        <div className="web-pg py-4 flex">
            <h3>Register</h3>
            <p>Register funktioner</p>

            <div className="divider_green"></div>

            <div className="web-row">
                <div className="flex-col flex">
                    { this.mnc("c1").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex-col flex">
                    { this.mnc("c2").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
  );
    }
}
export default withRouter(Reg_Home);
